import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f785b2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-answer" }
const _hoisted_2 = { class: "test-answer__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "test-answer__title" }, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("解答"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "かいとう"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1))
const _hoisted_4 = { class: "test-answer__list" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "test-answer__radiolabel",
  for: "item1"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  class: "test-answer__radiolabel",
  for: "item2"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "test-answer__radiolabel",
  for: "item3"
}

import { ref, toRefs, computed } from "vue"
import Tutorial from '@/components/tutorials/Example.vue'
import { Page } from "@/store/exam";

interface Props {
  selected: number,
  question: Page
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Answer',
  props: {
    selected: null,
    question: null
  },
  emits: ['selectAnswer'],
  setup(__props: any, { emit }) {

const props = __props as {
  selected: number,
  question: Page
};



const { selected, question } = toRefs(props);



const answer1 = ref();
const answer2 = ref();
const answer3 = ref();

const exampleAnswer = ref<number | undefined>(0);
const startTutorial = ref<boolean>(false);

const isExampleSelected = ref<boolean>(false);

const isReading = ref<boolean>(!question.value.audio);

const select = computed({
  get: () => selected.value,
  set: (value: number) => {
    if (!question.value.example) {
      emit('selectAnswer', value);
    }
  }
});

const selectExample = (val: number) => {
  emit('selectAnswer', val);
  isExampleSelected.value = true;
}

const init = () => {
  startTutorial.value = false;
  exampleAnswer.value = 0;

  if (question.value.example) {
    exampleAnswer.value = question.value.questions[0].answer;
    // TODO: 音声がある場合はパート毎に秒数決め打ち
    const delay = question.value.audioDuration ? question.value.audioDuration - 5 : 1;

    setTimeout(() => {
      startTutorial.value = true;
    }, delay * 1000);
  }
}
init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          ref_key: "answer1",
          ref: answer1
        }, [
          _withDirectives(_createElementVNode("input", {
            id: "item1",
            class: "test-answer__radio",
            type: "radio",
            name: "item",
            value: 1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(select) ? (select).value = $event : null)),
            disabled: isExampleSelected.value
          }, null, 8, _hoisted_5), [
            [_vModelRadio, _unref(select)]
          ]),
          _createElementVNode("label", _hoisted_6, [
            _createTextVNode(" 1 "),
            (startTutorial.value && exampleAnswer.value === 1)
              ? (_openBlock(), _createBlock(Tutorial, {
                  key: 0,
                  el: answer1.value,
                  onActionListener: _cache[1] || (_cache[1] = ($event: any) => (selectExample(1))),
                  repeat: isReading.value ? 1 : 0
                }, null, 8, ["el", "repeat"]))
              : _createCommentVNode("", true)
          ])
        ], 512),
        _createElementVNode("li", {
          ref_key: "answer2",
          ref: answer2
        }, [
          _withDirectives(_createElementVNode("input", {
            id: "item2",
            class: "test-answer__radio",
            type: "radio",
            name: "item",
            value: 2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(select) ? (select).value = $event : null)),
            disabled: isExampleSelected.value
          }, null, 8, _hoisted_7), [
            [_vModelRadio, _unref(select)]
          ]),
          _createElementVNode("label", _hoisted_8, [
            _createTextVNode(" 2 "),
            (startTutorial.value && exampleAnswer.value === 2)
              ? (_openBlock(), _createBlock(Tutorial, {
                  key: 0,
                  el: answer2.value,
                  onActionListener: _cache[3] || (_cache[3] = ($event: any) => (selectExample(2))),
                  repeat: isReading.value ? 1 : 0
                }, null, 8, ["el", "repeat"]))
              : _createCommentVNode("", true)
          ])
        ], 512),
        _createElementVNode("li", {
          ref_key: "answer3",
          ref: answer3
        }, [
          _withDirectives(_createElementVNode("input", {
            id: "item3",
            class: "test-answer__radio",
            type: "radio",
            name: "item",
            value: 3,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(select) ? (select).value = $event : null)),
            disabled: isExampleSelected.value
          }, null, 8, _hoisted_9), [
            [_vModelRadio, _unref(select)]
          ]),
          _createElementVNode("label", _hoisted_10, [
            _createTextVNode(" 3 "),
            (startTutorial.value && exampleAnswer.value === 3)
              ? (_openBlock(), _createBlock(Tutorial, {
                  key: 0,
                  el: answer3.value,
                  onActionListener: _cache[5] || (_cache[5] = ($event: any) => (selectExample(3))),
                  repeat: isReading.value ? 1 : 0
                }, null, 8, ["el", "repeat"]))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})